var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingIDs),
      expression: "shippingIDs"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "20"
    },
    domProps: {
      "value": (_vm.shippingIDs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingIDs = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.Update()
      }
    }
  }, [_vm._v(" Update "), _c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _vm._l((_vm.ResData), function(data) {
    return _c('div', [_vm._v("\n        Shipping ID: " + _vm._s(data.shippingID) + " "), _c('br'), _vm._v("\n        actionForInvestigation: " + _vm._s(data.actionForInvestigation) + " "), _c('br'), _vm._v("\n        RECManifest: " + _vm._s(data.RECManifest) + " "), _c('br'), _vm._v(" "), _c('hr')])
  })], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-385ede24","hasScoped":true}!./src/views/components/invScript/invScript.component.html
// module id = 483
// module chunks = 1